<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Nova grupa statusa</h5>
            </div>
            <div class="ibox-content">
                <osoba-tvrtka-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                >
                </osoba-tvrtka-forma>
            </div>
        </div>
    </div>
</template>

<script>
import OsobeNavigation from "../OsobeNavigation";
import OsobaTvrtkaForma from "./OsobaTvrtkaForma";
export default {
    name: "OsobaTvrtkaCreate",
    components: { OsobaTvrtkaForma, OsobeNavigation },
    data(){
        return {
            breadcrumbs: [],
            osoba_id: this.$route.params.osoba_id
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/tvrtke',
                    name: 'Tvrtke'
                },
                {
                    path: '/osobe/' + this.osoba_id + '/tvrtke/create',
                    name: 'Nova tvrtka'
                }
            ]
        }
    },
    mounted() {
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
